import { getConfigVoucher } from 'actions'
import CommonTable from 'components/common/commonTable'
import { P_IMPORT_ITEMS } from 'constants/ConfigProcessNames'
import { getDefaultColumns } from 'lib/FormUtils'
import { getFiltersData } from 'lib/Utils'
import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import _ from 'underscore'
import {
	IProductImportTableProps,
	IProductImportTableState
} from './ProductImportTableType'

class ProductImportTable extends Component<
	IProductImportTableProps,
	IProductImportTableState
> {
	primaryKey: string
	constructor(props: IProductImportTableProps) {
		super(props)
		this.state = {
			itemsTable: []
		}
		this.primaryKey = 'cod_int'
	}

	componentDidMount = () => {
		const { idOperacion } = this.props
		this.props.getConfigVoucher({ cod_proceso: P_IMPORT_ITEMS, idOperacion })
	}

	componentDidUpdate = (prevProps: IProductImportTableProps) => {
		const { pickStockData } = this.props
		if (prevProps.pickStockData !== pickStockData) {
			this.setState({ itemsTable: pickStockData?.items ?? [] })
		}
	}

	/**
	 * to add background color to table
	 * @param {object} row
	 * @returns styles object
	 */
	handleRowStyle = (row: any) => {
		const style: any = {}
		if (row.ind_error) {
			style.backgroundColor = '#FFCC99'
		} else if (!row.ind_error) {
			style.backgroundColor = '#33CCFF'
		}
		return style
	}

	render() {
		const { pickStockData, config, primaryKey, authUser } = this.props
		const { itemsTable } = this.state

		const fieldsTable = getFiltersData(config?.campos || [], {
			agrupador: 'grilla'
		})

		const paginationOptions = pickStockData
			? {
					pageStartIndex: 1,
					sizePerPage: pickStockData.page_size,
					page: pickStockData.page_number,
					totalSize: pickStockData.total_count
			  }
			: {}

		const propsTable = {
			keyField: primaryKey || this.primaryKey,
			remote: true,
			columns: !_.isEmpty(fieldsTable)
				? getDefaultColumns(fieldsTable, { authUser })
				: [],
			data: itemsTable,
			rowClasses: 'theme.tableRow',
			headerClasses: 'theme.tableHeader',
			paginationOptions,
			onTableChange: this.props.handleChangeTable,
			rowStyle: this.handleRowStyle
		}

		return (
			<Col sm={12}>{!_.isEmpty(config) && <CommonTable {...propsTable} />}</Col>
		)
	}
}

const mapStateToProps = ({ auth, voucher }: any) => {
	const config = voucher.config ? voucher.config[P_IMPORT_ITEMS] : null
	const { authUser } = auth
	return { authUser, config }
}

const mapDispatchToProps = { getConfigVoucher }

export default connect(mapStateToProps, mapDispatchToProps)(ProductImportTable)
